"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignProductDetailRequest = void 0;
var AssignProductDetailRequest = /** @class */ (function () {
    function AssignProductDetailRequest() {
    }
    return AssignProductDetailRequest;
}());
exports.AssignProductDetailRequest = AssignProductDetailRequest;
;
//# sourceMappingURL=assignProductDetail.request.js.map